registerComponent("product-blocks/product-generic-cards", function (component) {

});
